import type {IAdData} from '../../../definitions';

/** Set class to modify position and adjust right position to expand sky to the left */
export function handleAdExpandingSky(data: IAdData): void {
  if (data.target) {
    const adSky = data.target;
    const adSkyIframe = adSky.querySelector('iframe');
    const widthAd = data.slot.metaData[0].width;
    const widthSky = adSky.offsetWidth;

    // modify right or width only if widthSky !== widthAd
    if (widthSky > widthAd) {
      if (adSkyIframe) {
        adSkyIframe.style.right = `${widthSky - widthAd}px`;
      }
    } else if (widthSky < widthAd) {
      adSky.style.width = `${widthAd}px`;
    }

    // add global class to assign css rules to specific elements
    document.documentElement.classList.add('has-ad-expanding-sky');
  }
}
